import {type IAsset} from '@netx/core-asset-next/schema';
import {type IConstituentClip} from '../schema';
import {canManageConstituentClip} from './canManageConstituentClip';

export const canSetConsitutentClipThumbnail = (
	asset?: IAsset,
	constituentClip?: IConstituentClip,
) => {
	return (
		canManageConstituentClip(asset, constituentClip) &&
		constituentClip.display !== 1
	);
};
